"use client";
import { useId, Fragment } from "react";
import PropTypes from "prop-types";
import { Tab } from "@headlessui/react";

import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";

import styles from "./styles.module.css";

const PropertiesListWrap = ({ data }) => {
  const id = useId();

  return (
    <div className={styles.wrapper}>
      <Title>İlan Özellikleri</Title>
      <div className={styles.inner}>
        <Tab.Group>
          <Tab.List className={styles.tabTitles}>
            {Object.entries(data).map(([key], index) => (
              <Tab key={`${id}-${index}`}>{key}</Tab>
            ))}
          </Tab.List>
          <Tab.Panels className={styles.tabContents}>
            {Object.entries(data).map(([key, value], index) => (
              <Tab.Panel key={`${id}-${index}`}>
                <MoreContent defaultHeight={245}>
                  {Object.entries(value).map(([title, contentList], index) => (
                    <Fragment key={index}>
                      <div className={styles.tabContentTitle}>{title}</div>
                      <ul className={styles.tabContentList}>
                        {contentList.map((item, listIndex) => (
                          <li key={`${id}+${listIndex}`}>{item}</li>
                        ))}
                      </ul>
                    </Fragment>
                  ))}
                </MoreContent>
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
};

PropertiesListWrap.propTypes = {
  data: PropTypes.object,
};

export default PropertiesListWrap;
